<template>
  <div class="dynamic-tables">
    <h2 class="page-title text-center">Data Penilaian Laporan Tahunan</h2>
    <Widget customHeader>
      <div>
        <!-- prettier-ignore -->
        <div class="d-flex justify-content-between">
          <div>
            <button type="button" class="btn btn-success" @click="exportData">
              <i class="fa fa-file-text-o"></i> Excel
            </button>
          </div>
          <div class="d-flex">
            <div class="d-flex">
              <div class="d-flex align-items-center mr-2">
                <label for="search" class="mr-2 mb-0">Search: </label>
                <input
                  v-model="search.value"
                  type="text"
                  class="form-control"
                  id="search"
                />
              </div>
              <div>
                <select v-model="search.field" class="form-control">
                  <option value="nama_pemegang">Nama Pemohon</option>
                  <option value="jenis_kegiatan">Jenis Permohonan</option>
                  <option value="nomor_kkprl">Nomor Izin Terbit</option>
                  <option value="tanggal_penerbitan">Tanggal Izin Terbit</option>
                  <option value="tahun_laporan">Tahun Laporan</option>
                  <option value="tanggal_submit_laporan">Tanggal Pelaporan</option>
                  <option value="nilai">Nilai</option>
                  <option value="total_skor">Skor</option>
                  <option value="status_laporan">Status</option>
                  <option v-if="user.role==='superuser'" value="nama_penilai">Penilai</option>
                </select>
              </div>
            </div>
            <div class="d-flex ml-4">
              <div class="d-flex align-items-center mr-2">
                <label for="search" class="mb-0">Sort By: </label>
              </div>
              <div>
                <select v-model="sort.field" class="form-control">
                  <option value="tanggal_submit_laporan">Tanggal Pelaporan</option>
                  <option value="tanggal_penerbitan">Tanggal Izin Terbit</option>
                </select>
              </div>
              <div class="ml-2">
                <select v-model="sort.direction" class="form-control">
                  <option value="DESC">DESC</option>
                  <option value="ASC">ASC</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <table id="tabel_penilaian_laporan" class="table" style="width: 100%">
          <thead>
            <tr>
              <th>No</th>
              <th>Nama Pemohon</th>
              <th>Jenis Permohonan</th>
              <th>Nomor Izin Terbit</th>
              <th>Tanggal Izin Terbit</th>
              <th>Tahun Laporan</th>
              <th>Tanggal Pelaporan</th>
              <th>Nilai</th>
              <th>Skor</th>
              <th>Masa Berlaku</th>
              <th>Persetujuan Lingkungan</th>
              <th>Ket. Persetujuan Lingkungan</th>
              <th>Perizinan Usaha</th>
              <th>Ket. Perizinan Usaha</th>
              <th>Status</th>
              <th v-if="user.role === 'superuser'">Penilai</th>
              <th>Unduh File</th>
              <th
                v-if="
                  user.role !== 'ptsa' &&
                  user.role !== 'tim_teknis' &&
                  user.role !== 'admin_kkp'
                "
              >
                Aksi
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(data, index) in dataLaporan"
              :key="index"
              :class="[
                {
                  'text-danger':
                    data.status_laporan ===
                    'Komentar/Informasi terhadap Penyampaian Laporan Tahunan',
                },
              ]"
            >
              <!-- No -->
              <td>{{ index + pagination.firstInPage }}</td>
              <!-- Nama Pemohon -->
              <td>
                <div style="width: 300px; white-space: normal">
                  {{ data.nama_pemegang }}
                </div>
              </td>
              <!-- Jenis Permohonan -->
              <td>{{ data.jenis_kegiatan }}</td>
              <!-- Nomor Izin Terbit -->
              <td>{{ data.nomor_kkprl }}</td>
              <!-- Tanggal Izin Terbit -->
              <td>{{ formatDate(data.tanggal_penerbitan, 'DD MMMM YYYY') }}</td>
              <!-- Tahun Laporan -->
              <td>{{ data.tahun_laporan }}</td>
              <!-- Tanggal Pelaporan -->
              <td>
                {{ formatDate(data.tanggal_submit_laporan, 'DD MMMM YYYY') }}
              </td>
              <!-- Nilai -->
              <td>{{ data.nilai || '-' }}</td>
              <!-- Skor -->
              <td>{{ data.total_skor || '-' }}</td>
              <!-- Masa Berlaku -->
              <td>
                {{
                  data.masa_berlaku === null
                    ? '-'
                    : `${calculateMasaBerlaku(
                        data.masa_berlaku,
                        data.tanggal_penerbitan
                      )}`
                }}
              </td>
              <!-- Persetujuan Lingkungan -->
              <td>
                <span
                  v-if="
                    data.status_persetujuan_lingkungan === 'Sudah' &&
                    data.file_persetujuan_lingkungan !== null
                  "
                >
                  Ada - Dilampirkan
                </span>
                <span
                  v-if="
                    data.status_persetujuan_lingkungan === 'Sudah' &&
                    data.file_persetujuan_lingkungan === null
                  "
                >
                  Ada - Tidak Dilampirkan
                </span>
                <span
                  v-if="data.status_persetujuan_lingkungan === 'Belum Terbit'"
                >
                  Tidak Ada
                </span>
              </td>
              <!-- Ket. Persetujuan Lingkungan -->
              <td>
                <div
                  v-if="data.status_persetujuan_lingkungan === 'Sudah'"
                  style="width: 250px; white-space: normal"
                >
                  {{
                    `Izin lingkungan no. ${
                      data.nomor_persetujuan_lingkungan
                    } tanggal ${formatDate(
                      data.tanggal_terbit_persetujuan_lingkungan,
                      'DD/MM/YYYY'
                    )} instansi penerbit ${
                      data.instansi_penerbit_persetujuan_lingkungan
                    } masa berlaku ${
                      data.masa_berlaku_persetujuan_lingkungan
                    } tahun`
                  }}
                </div>
                <div v-else>-</div>
              </td>
              <!-- Perizinan Usaha -->
              <td>
                <template v-if="data.jenis_kegiatan === 'Berusaha'">
                  <span
                    v-if="
                      data.status_perizinan_berusaha === 'Sudah' &&
                      data.perizinan_berusaha.file_perizinan_berusaha !== null
                    "
                  >
                    Ada - Dilampirkan
                  </span>
                  <span
                    v-if="
                      data.status_perizinan_berusaha === 'Sudah' &&
                      data.perizinan_berusaha.file_perizinan_berusaha === null
                    "
                  >
                    Ada - Tidak Dilampirkan
                  </span>
                  <span v-if="data.status_perizinan_berusaha === 'Belum Terbit'"
                    >Tidak Ada</span
                  >
                </template>
                <template v-if="data.jenis_kegiatan === 'Non Berusaha'">
                  <span
                    v-if="
                      data.status_perizinan_nonberusaha === 'Sudah' &&
                      data.perizinan_nonberusaha.file_perizinan_nonberusaha !==
                        null
                    "
                  >
                    Ada - Dilampirkan
                  </span>
                  <span
                    v-if="
                      data.status_perizinan_nonberusaha === 'Sudah' &&
                      data.perizinan_nonberusaha.file_perizinan_nonberusaha ===
                        null
                    "
                  >
                    Ada - Tidak Dilampirkan
                  </span>
                  <span
                    v-if="data.status_perizinan_nonberusaha === 'Belum Terbit'"
                    >Tidak Ada</span
                  >
                </template>
              </td>
              <!-- Ket. Perizinan Usaha -->
              <td>
                <template v-if="data.jenis_kegiatan === 'Berusaha'">
                  <div
                    v-if="data.status_perizinan_berusaha === 'Sudah'"
                    style="width: 250px; white-space: normal"
                  >
                    {{
                      `Perizinan no. ${
                        data.perizinan_berusaha.nomor_perizinan_berusaha
                      } tanggal ${formatDate(
                        data.perizinan_berusaha
                          .tanggal_terbit_perizinan_berusaha,
                        'DD/MM/YYYY'
                      )} instansi penerbit ${
                        data.perizinan_berusaha
                          .instansi_penerbit_perizinan_berusaha
                      } masa berlaku ${
                        data.perizinan_berusaha.masa_berlaku_perizinan_berusaha
                      } tahun`
                    }}
                  </div>
                  <div v-else>-</div>
                </template>
                <template v-if="data.jenis_kegiatan === 'Non Berusaha'">
                  <div
                    v-if="data.status_perizinan_nonberusaha === 'Sudah'"
                    style="width: 250px; white-space: normal"
                  >
                    {{
                      `Perizinan no. ${
                        data.perizinan_nonberusaha.nomor_perizinan_nonberusaha
                      } tanggal ${formatDate(
                        data.perizinan_nonberusaha
                          .tanggal_terbit_perizinan_nonberusaha,
                        'DD/MM/YYYY'
                      )} instansi penerbit ${
                        data.perizinan_nonberusaha
                          .instansi_penerbit_perizinan_nonberusaha
                      } masa berlaku ${
                        data.perizinan_nonberusaha
                          .masa_berlaku_perizinan_nonberusaha
                      } tahun`
                    }}
                  </div>
                  <div v-else>-</div>
                </template>
              </td>
              <!-- Status -->
              <td>{{ data.status_laporan }}</td>
              <!-- Penilai -->
              <td v-if="user.role === 'superuser'">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="showModalTimPenilai(data.id)"
                  :disabled="
                    data.file_tanda_terima_laporan === null ||
                    data.status_laporan === 'Selesai'
                  "
                >
                  <i v-if="data.nama_penilai" class="fa fa-pencil" />
                  <i v-else class="fa fa-plus" />
                  {{
                    data.nama_penilai == null ? 'Belum Ada' : data.nama_penilai
                  }}
                </b-button>
              </td>
              <!-- Unduh File -->
              <td>
                <div style="width: 250px" class="row">
                  <div class="col-8">
                    <select
                      style="width: 150px; margin-right: 10px"
                      class="form-select"
                      v-model="data.selected_file"
                    >
                      <option disabled selected value="">- Pilih File -</option>
                      <option
                        :value="data.file_tanda_terima_laporan"
                        :disabled="data.file_tanda_terima_laporan === null"
                      >
                        Tanda Terima
                      </option>
                      <option
                        :value="data.filename_hasil_penilaian"
                        :disabled="data.filename_hasil_penilaian === null"
                      >
                        Hasil Penilaian
                      </option>
                    </select>
                  </div>
                  <div class="col-4 d-flex align-items-center">
                    <span v-if="data.selected_file !== '#'">
                      <a :href="data.selected_file" target="_blank"
                        ><i class="fa fa-download" style="font-size: 20px"
                      /></a>
                    </span>
                  </div>
                </div>
              </td>
              <!-- Aksi -->
              <td
                v-if="
                  user.role !== 'ptsa' &&
                  user.role !== 'tim_teknis' &&
                  user.role !== 'admin_kkp'
                "
              >
                <div style="width: 200px">
                  <b-button-toolbar>
                    <b-button
                      size="sm"
                      class="text-white m-1 bg-primary"
                      @click="showModalTracking(data.id, index)"
                    >
                      <i class="fa fa-search"></i> Tracking
                    </b-button>
                    <template v-if="user.role === 'superuser'">
                      <b-button
                        v-if="data.file_tanda_terima_laporan === null"
                        size="sm"
                        variant="secondary"
                        class="text-white m-1"
                        @click="showModalFinalisasi(data.id)"
                      >
                        <i class="fa fa-check"></i>
                        Buat Tanda Terima
                      </b-button>
                      <b-button
                        v-if="data.file_tanda_terima_laporan === null"
                        size="sm"
                        variant="warning"
                        class="text-white m-1"
                        @click="showModalCatatan(data.id)"
                      >
                        <i class="fa fa-sticky-note-o"></i>
                        Catatan
                      </b-button>
                    </template>
                    <template v-else>
                      <template v-if="data.file_tanda_terima_laporan !== null">
                        <b-button
                          v-if="data.status_laporan === 'Selesai'"
                          size="sm"
                          variant="info"
                          class="text-white m-1"
                          @click="verifikasiLaporan(data.id)"
                        >
                          <i class="fa fa-eye"></i> Detail Penilaian
                        </b-button>
                        <b-button
                          v-if="
                            data.status_laporan !== 'Selesai' &&
                            data.id_penilai !== null
                          "
                          size="sm"
                          variant="success"
                          class="text-white m-1"
                          @click="verifikasiLaporan(data.id)"
                        >
                          <i class="fa fa-check-square-o"></i> Verifikasi
                          Laporan
                        </b-button>
                        <b-button
                          v-if="data.status_penilaian_laporan === 'Draft'"
                          size="sm"
                          variant="warning"
                          class="text-white m-1"
                          @click="submitLaporan(data.id)"
                        >
                          <i class="fa fa-check-square"></i>
                          Submit
                        </b-button>
                      </template>
                    </template>
                    <template v-if="user.role === 'superuser'">
                      <b-button
                        size="sm"
                        variant="info"
                        class="text-white m-1"
                        @click="verifikasiLaporan(data.id)"
                      >
                        <i class="fa fa-eye"></i> Tinjau Laporan
                      </b-button>
                      <b-button
                        size="sm"
                        variant="danger"
                        class="text-white m-1"
                        @click="deleteLaporan(data.id)"
                      >
                        <i class="fa fa-trash-o"></i> Hapus Laporan
                      </b-button>
                    </template>
                  </b-button-toolbar>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- prettier-ignore -->
        <div class="d-flex justify-content-between mt-4">
          <div>
            <template v-if="pagination.total">
              Menampilkan {{ pagination.firstInPage }} sampai {{ pagination.currentPage !== pagination.lastPage ? pagination.limit*pagination.currentPage : pagination.total }} dari {{ pagination.total }} data
            </template>
          </div>
          <nav aria-label="Page navigation example">
            <ul class="pagination">
              <li :class="['page-item', {'disabled': pagination.currentPage === 1}]">
                <a class="page-link" href="#" aria-label="Previous" @click="changePage({option: 'first'})">
                  <span aria-hidden="true">Awal</span>
                </a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === 1}]">
                <a class="page-link" href="#" aria-label="Previous" @click="changePage({option: 'prev'})">
                  <span aria-hidden="true">Sebelumnya</span>
                </a>
              </li>
              <li 
                v-for="i in pagination.pageNumber" 
                class="page-item"
              >
                <a :class="['page-link', {'active': i === `${pagination.currentPage}`}]" href="#" @click="changePage({page: i})">{{ i }}</a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === pagination.lastPage}]">
                <a class="page-link" href="#" aria-label="Next" @click="changePage({option: 'next'})">
                  <span aria-hidden="true">Selanjutnya</span>
                </a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === pagination.lastPage}]">
                <a class="page-link" href="#" aria-label="Next" @click="changePage({option: 'last'})">
                  <span aria-hidden="true">Akhir</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </Widget>

    <b-modal id="modal-surat-tugas" title="Buat Surat Tugas" size="lg">
      <template>
        <b-form>
          <div class="row g-0">
            <div class="col-12">
              <label>Kepada</label>
              <v-select
                id="kepada"
                v-model="formSuratTugas.id_penilai"
                :reduce="(data) => data.id"
                label="nama"
                :options="dataUser"
                name="Kepada"
                v-validate="'required'"
              />
              <span class="text-danger" v-if="errors.has('Kepada')">
                {{ errors.first('Kepada') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label>Menimbang</label>
              <ckeditor
                id="menimbang"
                :editor="wygEditor"
                v-model="formSuratTugas.menimbang"
                name="Menimbang"
                v-validate="'required'"
              ></ckeditor>
              <span class="text-danger" v-if="errors.has('Menimbang')">
                {{ errors.first('Menimbang') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label>Dasar</label>
              <ckeditor
                id="dasar"
                :editor="wygEditor"
                v-model="formSuratTugas.dasar"
                name="Dasar"
                v-validate="'required'"
              ></ckeditor>
              <span class="text-danger" v-if="errors.has('Dasar')">
                {{ errors.first('Dasar') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label>Untuk</label>
              <ckeditor
                id="untuk"
                :editor="wygEditor"
                v-model="formSuratTugas.untuk"
                name="Untuk"
                v-validate="'required'"
              ></ckeditor>
              <span class="text-danger" v-if="errors.has('Untuk')">
                {{ errors.first('Untuk') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label>Paragraf Penutup</label>
              <ckeditor
                id="paragraf_penutup"
                :editor="wygEditor"
                v-model="formSuratTugas.paragraf_penutup"
                name="Paragraf Penutup"
                v-validate="'required'"
              ></ckeditor>
              <span class="text-danger" v-if="errors.has('Paragraf Penutup')">
                {{ errors.first('Paragraf Penutup') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label>Catatan Surat</label>
              <ckeditor
                id="catatan_surat"
                :editor="wygEditor"
                v-model="formSuratTugas.catatan_surat"
                name="Catatan Surat"
              ></ckeditor>
            </div>
            <div class="col-12 mt-3">
              <div class="row g-3">
                <div class="col-md-6">
                  <label>Tempat</label>
                  <b-form-input
                    id="tempat_ttd"
                    v-model="formSuratTugas.tempat_ttd"
                    v-validate="'required'"
                    name="Tempat"
                  ></b-form-input>
                  <span class="text-danger" v-if="errors.has('Tempat')">
                    {{ errors.first('Tempat') }}
                  </span>
                </div>
                <div class="col-md-6">
                  <label>Tanggal Surat</label>
                  <DatePicker
                    id="tgl_surat"
                    lang="en"
                    :placeholder="tgl_surat"
                    input-class="form-control"
                    @change="
                      (val) => {
                        this.tgl_surat = val.toLocaleDateString('en-GB')
                        this.formSuratTugas.tanggal_surat = formatDate(
                          val,
                          'YYYY-MM-DD'
                        )
                        this.removeFormError('Tanggal Surat')
                      }
                    "
                    class="w-100"
                  >
                    <i class="fa fa-calendar-o" slot="calendar-icon" />
                  </DatePicker>
                  <span class="text-danger" v-if="errors.has('Tanggal Surat')">
                    {{ errors.first('Tanggal Surat') }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3">
              <div class="row g-3">
                <div class="col-md-6">
                  <label>Paraf Persetujuan</label>
                  <v-select
                    id="paraf_persetujuan"
                    v-model="formSuratTugas.paraf_persetujuan"
                    :reduce="(data) => data.id_user"
                    label="nama_lengkap"
                    :options="dataPetugasPenerima"
                    name="Paraf Persetujuan"
                    v-validate="'required'"
                  />
                  <span
                    class="text-danger"
                    v-if="errors.has('Paraf Persetujuan')"
                  >
                    {{ errors.first('Paraf Persetujuan') }}
                  </span>
                </div>
                <div class="col-md-6">
                  <label>Penandatangan</label>
                  <v-select
                    id="penandatangan"
                    v-model="formSuratTugas.penandatangan"
                    :reduce="(data) => data.id_user"
                    label="nama_lengkap"
                    :options="dataPetugasPenerima"
                    name="Penandatangan"
                    v-validate="'required'"
                  />
                  <span class="text-danger" v-if="errors.has('Penandatangan')">
                    {{ errors.first('Penandatangan') }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="saveSuratTugas"
          >
            <img src="../../assets/icons/archive.svg" />
            Buat
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="modal-finalisasi-surat-tugas"
      title="Penomoran Surat Tugas"
      size="md"
    >
      <template>
        <b-form>
          <div class="row g-0">
            <div class="col-12">
              <label>Nomor Surat</label>
              <b-form-input
                id="nomor_surat"
                v-model="formFinalisasiSuratTugas.nomor_surat"
                v-validate="'required'"
                name="Nomor Surat"
              ></b-form-input>
              <span class="text-danger" v-if="errors.has('Nomor Surat')">
                {{ errors.first('Nomor Surat') }}
              </span>
            </div>
          </div>
        </b-form>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="saveFinalisasiSuratTugas"
          >
            <img src="../../assets/icons/archive.svg" />
            Simpan
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="modal-finalisasi-tanda-terima"
      title="Buat Tanda Terima"
      size="md"
    >
      <template>
        <b-form>
          <div class="row g-0">
            <div class="col-12">
              <label>Jenis KKPRL</label>
              <v-select
                v-model="formFinalisasiTandaTerima.jenis_kkprl"
                id="jenis_kkprl"
                :reduce="(data) => data.value"
                label="text"
                :options="optionJenisKkprl"
                name="Jenis KKPRL"
                v-validate="'required'"
              />
              <span class="text-danger" v-if="errors.has('Jenis KKPRL')">
                {{ errors.first('Jenis KKPRL') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label>Kategori</label>
              <v-select
                v-model="formFinalisasiTandaTerima.kategori"
                id="kategori"
                :reduce="(data) => data.value"
                label="text"
                :options="optionKategori"
                name="Kategori"
                v-validate="'required'"
              />
              <span class="text-danger" v-if="errors.has('Kategori')">
                {{ errors.first('Kategori') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label>Petugas Penerima</label>
              <v-select
                v-model="formFinalisasiTandaTerima.id_petugas_penerima"
                id="petugas_penerima"
                :reduce="(data) => data.id"
                label="nama_lengkap"
                :options="dataPetugasPenerima"
                name="Petugas Penerima"
                v-validate="'required'"
              />
              <span class="text-danger" v-if="errors.has('Petugas Penerima')">
                {{ errors.first('Petugas Penerima') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label>Catatan</label>
              <ckeditor
                id="catatan"
                :editor="wygEditor"
                v-model="formFinalisasiTandaTerima.catatan_penerimaan"
                name="Catatan"
              ></ckeditor>
            </div>
          </div>
        </b-form>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="saveFinalisasiTandaTerima"
          >
            <img src="../../assets/icons/archive.svg" />
            Buat
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="modal-tim-penilai"
      size="sm"
      body-class="bg-white"
      title="Penilai"
    >
      <template>
        <b-form-group label="Nama Penilai" label-for="nama-penilai">
          <v-select
            id="nama-penilai"
            v-model="formTimPenilai.id_penilai"
            :reduce="(data) => data.id"
            label="nama"
            :options="dataUser"
            name="Nama Penilai"
            v-validate="'required'"
          />
          <span class="text-danger" v-if="errors.has('Nama Penilai')">
            {{ errors.first('Nama Penilai') }}
          </span>
        </b-form-group>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right m-1"
            @click="saveTimPenilai"
          >
            Tugaskan
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modal-catatan" title="Catatan" size="md">
      <template>
        <b-form>
          <div class="row g-0">
            <div class="col-12">
              <label>Catatan</label>
              <ckeditor
                id="catatan"
                :editor="wygEditor"
                v-model="formCatatan"
                name="Catatan"
                v-validate="'required'"
              ></ckeditor>
              <span class="text-danger" v-if="errors.has('Catatan')">
                {{ errors.first('Catatan') }}
              </span>
            </div>
          </div>
        </b-form>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="sendCatatan"
          >
            <i class="fa fa-paper-plane-o"></i>
            Kirim
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="modal-tracking"
      title="Tracking Laporan Tahunan"
      size="lg"
      scrollable
    >
      <template>
        <ul class="timeline">
          <li v-for="(item, index) in trackingPermohonan">
            <span class="eventIcon eventIconPrimary"></span>
            <section class="event">
              <span class="thumb-xs avatar pull-left me-sm-1"> </span>
              <h5 class="eventHeading">
                <a href="#">{{ item.status_laporan }}</a>
              </h5>
              <small>{{ item.nama_pemegang }}</small>
              <p class="fs-sm text-muted">
                {{ formatDate(item.createdAt, 'HH:mm - DD MMMM YYYY') }}
              </p>
              <div class="text-danger" v-html="item.catatan"></div>
            </section>
          </li>
        </ul>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="danger"
            size="sm"
            class="float-right"
            @click="$bvModal.hide('modal-tracking')"
          >
            Tutup
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<style>
table.table.b-table > thead > tr > th[aria-sort='ascending']::after,
table.table.b-table > tfoot > tr > th[aria-sort='ascending']::after {
  opacity: 1;
  content: '\2191';
}

.dt-button.btn.btn-primary {
  border: none;
}

.dt-button.btn.btn-primary:hover {
  background-color: #35a0fd !important;
  border: none;
}

.modal-body {
  background: eaf0f6 !important;
}

#tabel_penilaian_laporan_info,
#tabel_penilaian_laporan_paginate,
#tabel_penilaian_laporan_filter {
  display: none;
}
</style>

<script>
import Widget from '@/components/Widget/Widget'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import vSelect from 'vue-select'
import VueLoading from 'vuejs-loading-plugin'
import Vue from 'vue'
import { formatDate } from '../../helper/helpernew'
import axios from 'axios'
import Swal from 'sweetalert2'
import DatePicker from 'vue2-datepicker'
import * as xlsx from 'xlsx'

// using default options
Vue.use(VueLoading)

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: 'Loading', // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: 'rgb(255,255,255)', // set custom background
  classes: ['myclass'], // array, object or string
})

export default {
  name: 'Dynamic',
  components: { Widget, vSelect, DatePicker },
  data() {
    return {
      id_laporan_tahunan: null,
      id_surat_tugas: null,
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      formTimPenilai: {
        id_penilai: null,
      },
      formFinalisasiTandaTerima: {},
      formSuratTugas: {
        id_penilai: null,
        menimbang: '',
        dasar: '',
        untuk: '',
        paragraf_penutup: '',
        catatan_surat: '',
        tempat_ttd: null,
        tanggal_surat: null,
        paraf_persetujuan: null,
        penandatangan: null,
      },
      formFinalisasiSuratTugas: {
        nomor_surat: null,
      },
      formCatatan: '',
      dataLaporan: [],
      popoverShow: {},
      trackingPermohonan: [],
      optionJenisKkprl: [
        { value: 'Persetujuan', text: 'Persetujuan' },
        { value: 'Konfirmasi', text: 'Konfirmasi' },
      ],
      optionKategori: [
        { value: 'Pelaku Usaha', text: 'Pelaku Usaha' },
        { value: 'Perorangan', text: 'Perorangan' },
        { value: 'Pemerintah', text: 'Pemerintah' },
        { value: 'Pemerintah Daerah', text: 'Pemerintah Daerah' },
        { value: 'Lainnya', text: 'Lainnya' },
      ],
      tgl_surat: 'dd/mm/yyyy',
      dataPetugasPenerima: [],
      dataUser: [],
      wygEditor: ClassicEditor,
      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      search: {
        field: 'nama_pemegang',
        value: '',
      },
      sort: {
        field: 'tanggal_submit_laporan',
        direction: 'DESC',
      },
      debounceTerm: null,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    formatDate,

    showModalTracking(id, index) {
      // this.selectedPermohonan = this.dataLaporan[index]
      axios
        .get(
          this.baseapi + `api/status_laporan_tahunan?filter=id_laporan,=,${id}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          this.trackingPermohonan = res.data.data
        })
      this.$bvModal.show('modal-tracking')
    },

    sendCatatan() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          axios
            .post(
              this.baseapi + `api/laporan_tahunan/${this.id_laporan_tahunan}`,
              { catatan_laporan_tahunan: this.formCatatan },
              {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              Swal.fire('Berhasil', 'Berhasil mengirim catatan', 'success')
              this.$bvModal.hide('modal-catatan')
              this.loadData()
            })
            .catch((err) => {
              Swal.fire('Gagal', 'Gagal mengirim catatan', 'error')
            })
        }
      })
    },

    showModalCatatan(id_laporan) {
      this.id_laporan_tahunan = id_laporan
      this.$bvModal.show('modal-catatan')

      axios
        .get(this.baseapi + `api/laporan_tahunan/${id_laporan}`, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((res) => {
          this.formCatatan = res.data.data.catatan_laporan_tahunan
        })
    },

    async showModalTimPenilai(id_laporan) {
      this.id_laporan_tahunan = id_laporan
      this.$bvModal.show('modal-tim-penilai')

      const req = await axios.get(
        this.baseapi +
          'api/user?filter=role,=,tim_penilai_pusat;role,=,tim_penilai_upt&concat=or',
        {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        }
      )
      this.dataUser = req.data.data

      axios
        .get(this.baseapi + `api/laporan_tahunan/${id_laporan}`, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((res) => {
          const data = res.data.data
          if (data) {
            this.formTimPenilai.id_penilai = data.id_penilai
          } else {
            this.formTimPenilai.id_penilai = null
          }
        })
    },

    saveTimPenilai() {
      this.$validator.validateAll().then(async (res) => {
        if (res) {
          this.formSuratTugas.id_penilai = this.formTimPenilai.id_penilai
          const data = {
            id_penilai: this.formTimPenilai.id_penilai,
          }

          const checkTtd = await axios
            .get(
              this.baseapi +
                `api/tandatangan?filter=id_user,=,${this.formTimPenilai.id_penilai}`,
              {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => res.data.data)

          if (checkTtd.length > 0) {
            axios
              .post(
                this.baseapi + `api/laporan_tahunan/${this.id_laporan_tahunan}`,
                data,
                {
                  headers: {
                    Authorization: `Bearer ` + this.user.accessToken,
                  },
                }
              )
              .then((res) => {
                this.$bvModal.hide('modal-tim-penilai')
                Swal.fire('Berhasil', 'Berhasil memperbarui Penilai', 'success')
                this.loadData()
              })
              .catch((error) => {
                Swal.fire('Gagal', 'Gagal memperbarui Penilai', 'error')
              })
          } else {
            Swal.fire('Gagal', 'Penilai belum mempunyai tandatangan', 'error')
          }
        }
      })
    },

    showModalSuratTugas(id) {
      this.id_laporan_tahunan = id
      this.$bvModal.show('modal-surat-tugas')

      axios
        .get(this.baseapi + 'api/user?filter=role,=,admin_kkp', {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataUser = response.data.data
        })
        .catch((error) => {})

      axios
        .get(this.baseapi + 'api/tandatangan', {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPetugasPenerima = response.data.data
        })
        .catch((error) => {})

      axios
        .get(this.baseapi + `api/laporan_tahunan/${id}`, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((res) => {
          this.formSuratTugas.id_penilai = res.data.data.id_penilai
        })

      axios
        .get(
          this.baseapi + `api/surat_tugas_laporan?filter=id_laporan,=,${id}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          let data = response.data.data

          if (data.length === 0) {
            this.removeFormError('Tanggal Surat')
            Object.assign(this.formSuratTugas, {
              menimbang: '',
              dasar: '',
              untuk: '',
              paragraf_penutup: '',
              catatan_surat: '',
              tempat_ttd: null,
              tanggal_surat: null,
              paraf_persetujuan: null,
              penandatangan: null,
            })
            this.tgl_surat = 'dd/mm/yyyy'
          } else {
            this.id_surat_tugas = data[0].id
            this.formSuratTugas.id_penilai = data[0].id_penilai
            this.formSuratTugas.menimbang = data[0].menimbang
            this.formSuratTugas.dasar = data[0].dasar
            this.formSuratTugas.untuk = data[0].untuk
            this.formSuratTugas.paragraf_penutup = data[0].paragraf_penutup
            this.formSuratTugas.catatan_surat = data[0].catatan_surat
            this.formSuratTugas.tempat_ttd = data[0].tempat_ttd
            this.formSuratTugas.tanggal_surat = data[0].tanggal_surat
            this.formSuratTugas.paraf_persetujuan = data[0].paraf_persetujuan
            this.formSuratTugas.penandatangan = data[0].penandatangan
            this.tgl_surat = formatDate(data[0].tanggal_surat, 'DD/MM/YYYY')
          }
        })
        .catch((error) => {})
    },

    showModalFinalisasi(id) {
      this.id_laporan_tahunan = id
      this.$bvModal.show('modal-finalisasi-tanda-terima')

      axios
        .get(this.baseapi + 'api/tandatangan?filter=role,=,admin_kkp', {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPetugasPenerima = response.data.data
        })
        .catch((error) => {})
    },

    saveFinalisasiTandaTerima() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const formData = new FormData()
          // prettier-ignore
          {
            formData.append('jenis_kkprl', this.formFinalisasiTandaTerima.jenis_kkprl)
            formData.append('kategori', this.formFinalisasiTandaTerima.kategori)
            formData.append('id_petugas_penerima', this.formFinalisasiTandaTerima.id_petugas_penerima)
            formData.append('catatan_penerimaan', this.formFinalisasiTandaTerima.catatan_penerimaan || "")
          }

          axios
            .post(
              this.baseapi + `api/laporan_tahunan/${this.id_laporan_tahunan}`,
              formData,
              {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((response) => {
              window.open(response.data.data.file_tanda_terima_laporan)
              Swal.fire('Berhasil', 'Berhasil membuat Tanda Terima', 'success')
              this.$bvModal.hide('modal-finalisasi-tanda-terima')
              this.loadData()
              this.formFinalisasiTandaTerima = {}
            })
            .catch((error) => {
              Swal.fire('Gagal', 'Gagal membuat Tanda Terima', 'error')
            })
        }
      })
    },

    saveSuratTugas() {
      if (this.formSuratTugas.tanggal_surat === null) {
        this.addFormError('Tanggal Surat')
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          const data = {
            id_laporan: this.id_laporan_tahunan,
            id_penilai: this.formSuratTugas.id_penilai,
            menimbang: this.formSuratTugas.menimbang,
            dasar: this.formSuratTugas.dasar,
            untuk: this.formSuratTugas.untuk,
            paragraf_penutup: this.formSuratTugas.paragraf_penutup,
            catatan_surat: this.formSuratTugas.catatan_surat,
            tempat_ttd: this.formSuratTugas.tempat_ttd,
            tanggal_surat: this.formSuratTugas.tanggal_surat,
            paraf_persetujuan: this.formSuratTugas.paraf_persetujuan,
            penandatangan: this.formSuratTugas.penandatangan,
          }

          let res = false
          if (this.id_surat_tugas === null) {
            res = axios
              .post(this.baseapi + `api/surat_tugas_laporan`, data, {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              })
              .then((response) => {
                this.$bvModal.hide('modal-surat-tugas')
                Swal.fire('Berhasil', 'Berhasil membuat Surat Tugas', 'success')
                this.loadData()
                return true
              })
              .catch((error) => {
                Swal.fire('Gagal', 'Gagal membuat Surat Tugas', 'error')
              })
          } else {
            res = axios
              .put(
                this.baseapi + `api/surat_tugas_laporan/${this.id_surat_tugas}`,
                data,
                {
                  headers: {
                    Authorization: `Bearer ` + this.user.accessToken,
                  },
                }
              )
              .then((response) => {
                this.$bvModal.hide('modal-surat-tugas')
                Swal.fire(
                  'Berhasil',
                  'Berhasil memperbarui Surat Tugas',
                  'success'
                )
                this.loadData()
                return true
              })
              .catch((error) => {
                Swal.fire('Gagal', 'Gagal memperbarui Surat Tugas', 'error')
              })
          }

          res.then((response) => {
            if (response) {
              this.formSuratTugas = {
                id_penilai: null,
                menimbang: '',
                dasar: '',
                untuk: '',
                paragraf_penutup: '',
                catatan_surat: '',
                tempat_ttd: null,
                tanggal_surat: null,
                paraf_persetujuan: null,
                penandatangan: null,
              }
              this.tgl_surat = 'dd/mm/yyyy'
              this.id_surat_tugas = null
            }
          })
        }
      })
    },

    showModalFinalisasiSuratTugas(id) {
      if (id === null) return

      this.id_laporan_tahunan = id
      this.$bvModal.show('modal-finalisasi-surat-tugas')

      axios
        .get(
          this.baseapi + `api/surat_tugas_laporan?filter=id_laporan,=,${id}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          this.id_surat_tugas = res.data.data[0].id
        })
    },

    saveFinalisasiSuratTugas() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          const data = {
            nomor_surat: this.formFinalisasiSuratTugas.nomor_surat,
            status_pembuatan: 'Selesai',
          }

          axios
            .put(
              this.baseapi + `api/surat_tugas_laporan/${this.id_surat_tugas}`,
              data,
              {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$bvModal.hide('modal-finalisasi-surat-tugas')
              Swal.fire(
                'Berhasil',
                'Berhasil melakukan finalisasi Surat Tugas',
                'success'
              )
              this.loadData()
            })
            .catch((err) => {
              Swal.fire(
                'Gagal',
                'Gagal melakukan finalisasi Surat Tugas',
                'error'
              )
            })
        }
      })
    },

    addFormError(fieldName) {
      this.errors.add({
        field: fieldName,
        msg: `The ${fieldName} field is required`,
      })
    },

    removeFormError(fieldName) {
      this.errors.remove(fieldName)
    },

    verifikasiLaporan(id) {
      axios
        .get(this.baseapi + `api/penilaian_laporan?filter=id_laporan,=,${id}`, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((res) => {
          const data = res.data.data[0]
          let url = `/app/penilaian-laporan-tahunan/verifikasi?id_laporan=${id}`
          if (data) {
            url += `&id_penilaian=${data.id}`
          }
          this.$router.push(url)
        })
    },

    async submitLaporan(id) {
      const confirm = await Swal.fire({
        title: 'Apakah anda yakin ingin submit penilaian?',
        showDenyButton: true,
        confirmButtonText: 'Submit',
        denyButtonText: 'Batal',
      })
      if (!confirm.isConfirmed) return false
      const id_penilaian = await axios
        .get(this.baseapi + `api/penilaian_laporan?filter=id_laporan,=,${id}`, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((res) => {
          return res.data.data[0].id
        })

      axios
        .put(
          this.baseapi + `api/penilaian_laporan/${id_penilaian}`,
          { status: 'Selesai' },
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          axios.post(
            this.baseapi + `api/laporan_tahunan/${id}`,
            { status_penilaian_laporan: 'Selesai' },
            {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          Swal.fire('Berhasil', 'Berhasil submit penilaian', 'success')
          this.loadData()
        })
        .catch((err) => {
          axios.post(
            this.baseapi + `api/laporan_tahunan/${id}`,
            { status_penilaian_laporan: 'Draft' },
            {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          Swal.fire('Gagal', 'Gagal submit penilaian', 'error')
        })
    },

    async getData() {
      $('#tabel_penilaian_laporan').DataTable().destroy()
      return this.loadData()
    },

    async loadData() {
      // const api = `api/laporan_tahunan`
      // prettier-ignore
      const api = `api/laporan_tahunan/dataTable`+
        `?page=${this.pagination.currentPage}`+
        `&filter=status_laporan,!=,null;status_laporan,!=,Draft${this.user.role==='tim_penilai_upt'||this.user.role==='tim_penilai_pusat'?`;id_penilai,=,${this.user.id}`:''}${this.search.value!==''?`;${this.search.field},${this.search.field==='tanggal_submit_laporan'||this.search.field==='tanggal_penerbitan'||this.search.field==='total_skor'?'>=':'like'},${this.search.value}`:''}`+
        `&sort=${this.sort.field},${this.sort.direction}`
      axios
        .get(this.baseapi + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          const res = response.data
          this.pagination.limit = res.limit
          this.pagination.total = res.total
          this.pagination.firstInPage =
            (this.pagination.currentPage - 1) * res.limit + 1
          this.pagination.lastPage = Math.ceil(res.total / res.limit)
          this.setPagination()

          // x.status_laporan !== null && x.status_laporan !== 'Draft'

          const data = []
          for (const x of response.data.data) {
            data.push({ ...x, selected_file: '#' })
          }
          this.dataLaporan = data
        })
        .catch((error) => {})
        .finally(() => {
          this.initDatatable()
        })
    },

    setPagination() {
      this.$router
        .replace({
          path: this.$route.path,
          query: { page: this.pagination.currentPage },
        })
        .catch((err) => {})
      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (
          this.pagination.currentPage >=
          this.pagination.lastPage - 2
        ) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getData()
      $('html,body').scrollTop(1000)
    },

    deleteLaporan(id) {
      Swal.fire({
        title: 'Apakah Anda yakin?',
        text: 'Anda tidak akan dapat mengembalikan data ini!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, hapus',
        cancelButtonText: 'Batal',
      }).then(async (result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapi + 'api/laporan_tahunan/' + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((response) => {
              Swal.fire(
                'Berhasil',
                'Berhasil menghapus laporan tahunan',
                'success'
              )
              $('#tabel_penilaian_laporan').DataTable().destroy()
              this.loadData()
            })
            .catch((error) => {
              Swal.fire('Gagal', 'Gagal menghapus laporan tahunan', 'error')
            })
        }
      })
    },

    calculateMasaBerlaku(masa_berlaku, terbit_kkprl) {
      const t_masa_berlaku = new Date(masa_berlaku).getDate()
      if (!isNaN(t_masa_berlaku)) {
        const d1 = new Date(masa_berlaku)
        const d2 = new Date(terbit_kkprl)
        return `${Math.abs(d1.getFullYear() - d2.getFullYear())} tahun`
      } else {
        return '-'
      }
    },

    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment('DD MMMM YYYY')
        var t = $('#tabel_penilaian_laporan').DataTable({
          pagingType: 'full_numbers',
          language: {
            info: 'Menampilkan _START_ sampai _END_ dari _TOTAL_ data',
            paginate: {
              first: 'Awal',
              last: 'Akhir',
              next: 'Selanjutnya',
              previous: 'Sebelumnya',
            },
          },
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 2, right: 1 },
          scrollX: true,
          dom: 'Bfrtip',
          // fnRowCallback: function (
          //   nRow,
          //   aData,
          //   iDisplayIndex,
          //   iDisplayIndexFull
          // ) {
          //   //debugger;
          //   var index = iDisplayIndexFull + 1
          //   $('td:first', nRow).html(index)
          //   return nRow
          // },
          buttons: [
            // {
            //   extend: 'excelHtml5',
            //   title: 'Penilaian Laporan Tahunan',
            //   text: '<i class="fa fa-file-text-o"></i> Excel',
            //   className: 'btn text-white btn-success',
            //   exportOptions: {
            //     columns:
            //       this.user.role === 'superuser'
            //         ? [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
            //         : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
            //     orthogonal: 'export',
            //   },
            //   filename: function () {
            //     var today = new Date()
            //     var date =
            //       today.getFullYear() +
            //       '-' +
            //       (today.getMonth() + 1) +
            //       '-' +
            //       today.getDate()
            //     return 'Data Penilaian ' + date
            //   },
            // },
          ],
        })

        // t.on('order.dt search.dt', function () {
        //   t.column(0, { search: 'applied', order: 'applied' })
        //     .nodes()
        //     .each(function (cell, i) {
        //       cell.innerHTML = i + 1
        //     })
        // }).draw()
      }, 300)
    },

    // prettier-ignore
    exportData() {
      this.$loading(true);
      const api = `api/laporan_tahunan`+
        `?sort=${this.sort.field},${this.sort.direction}`+
        `&filter=status_laporan,!=,null;status_laporan,!=,Draft${this.user.role!=='superuser'?`;id_penilai,=,${this.user.id}`:''}${this.search.value!==''?`;${this.search.field},${this.search.field==='tanggal_submit_laporan'||this.search.field==='tanggal_penerbitan'||this.search.field==='total_skor'?'>=':'like'},${this.search.value}`:''}`
      axios.get(this.baseapi + api, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then((res) => {
        const worksheetData = [
          ['Laporan Tahunan'], 
          ['No', 'Nama Pemohon', 'Email', 'No Telepon', 'Jenis Permohonan', 'Nomor Izin Terbit', 'Tanggal Izin Terbit', 'Tahun Laporan', 'Tanggal Pelaporan', 'Tanggal Penilaian', 'Nilai', 'Skor', 'Masa Berlaku', 'Persetujuan Lingkungan', 'Ket. Persetujuan Lingkungan', 'File Persetujuan Lingkungan', 'Perizinan Usaha', 'Ket. Perizinan Usaha', 'File Perizinan Usaha', 'Status', 'K1', 'Ket K1', 'K4', 'Ket K4', 'K5', 'Ket K5', 'K8', 'Ket K8', 'K10', 'Ket K10'],
        ]
        if (this.user.role==='superuser') {
          worksheetData[1].push('Penilai')
        }
        const merge = [{ s: { c: 0, r: 0 },  e: { c: worksheetData[1].length-1, r: 0 }, }]
        res.data.data.map((d, i) => {
          const temp = [
            i+1,
            d.nama_pemegang||'',
            d.email||'',
            d.no_telepon||'',
            d.jenis_kegiatan||'',
            d.nomor_kkprl||'',
            d.tanggal_penerbitan||'',
            d.tahun_laporan||'',
            d.tanggal_submit_laporan||'',
            d.tanggal_penilaian||'',
            d.nilai,
            d.total_skor||'',
            d.masa_berlaku?this.calculateMasaBerlaku(d.masa_berlaku,d.tanggal_penerbitan):'',
            d.status_persetujuan_lingkungan==='Sudah'?d.file_persetujuan_lingkungan?'Ada - Dilampirkan':'Ada - Tidak Dilampirkan':'Tidak Ada',
            d.status_persetujuan_lingkungan==='Sudah'?`Izin lingkungan no. ${d.nomor_persetujuan_lingkungan} tanggal ${this.formatDate(d.tanggal_terbit_persetujuan_lingkungan,'DD/MM/YYYY')} instansi penerbit ${d.instansi_penerbit_persetujuan_lingkungan} masa berlaku ${d.masa_berlaku_persetujuan_lingkungan} tahun`:'',
            d.file_persetujuan_lingkungan||'',
            d.jenis_kegiatan==='Berusaha'?
              d.status_perizinan_berusaha==='Sudah'?d.perizinan_berusaha.file_perizinan_berusaha?'Ada - Dilampirkan':'Ada - Tidak Dilampirkan':'Tidak Ada':
              d.status_perizinan_nonberusaha==='Sudah'?d.perizinan_nonberusaha.file_perizinan_nonberusaha?'Ada - Dilampirkan':'Ada - Tidak Dilampirkan':'Tidak Ada',
            d.jenis_kegiatan==='Berusaha'?
              d.status_perizinan_berusaha==='Sudah'?`Perizinan no. ${d.perizinan_berusaha.nomor_perizinan_berusaha} tanggal ${this.formatDate(d.perizinan_berusaha.tanggal_terbit_perizinan_berusaha,'DD/MM/YYYY')} instansi penerbit ${d.perizinan_berusaha.instansi_penerbit_perizinan_berusaha} masa berlaku ${d.perizinan_berusaha.masa_berlaku_perizinan_berusaha} tahun`:'':
              d.status_perizinan_nonberusaha==='Sudah'?`Perizinan no. ${d.perizinan_nonberusaha.nomor_perizinan_nonberusaha} tanggal ${this.formatDate(d.perizinan_nonberusaha.tanggal_terbit_perizinan_nonberusaha,'DD/MM/YYYY')} instansi penerbit ${d.perizinan_nonberusaha.instansi_penerbit_perizinan_nonberusaha} masa berlaku ${d.perizinan_nonberusaha.masa_berlaku_perizinan_nonberusaha} tahun`:'',
            d.jenis_kegiatan==='Berusaha'?
              d.perizinan_berusaha?.file_perizinan_berusaha:
              d.perizinan_nonberusaha?.file_perizinan_nonberusaha,
            d.status_laporan||'Laporan tahunan belum lengkap',
            d.status_kewajiban_1,
            d.bentuk_kegiatan_1,
            d.status_kewajiban_4,
            d.bentuk_kegiatan_4,
            d.status_kewajiban_5,
            d.bentuk_kegiatan_5,
            d.status_kewajiban_8,
            d.bentuk_kegiatan_8,
            d.status_kewajiban_10,
            d.bentuk_kegiatan_10,
          ]
          if (this.user.role==='superuser') {
            temp.push(d.nama_penilai)
          }
          worksheetData.push(temp)
        })

        const workbook = xlsx.utils.book_new();
        const worksheet = xlsx.utils.aoa_to_sheet(worksheetData);
        worksheet["!merges"] = merge;
        xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const d = new Date();
        xlsx.writeFile(workbook, `Laporan Tahunan ${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}.xlsx`);
      }).catch((err) => {
        Swal.fire('Gagal', 'Gagal mengekspor data', 'error')
      }).finally(() => {
        this.$loading(false)
      })
    },
  },

  watch: {
    search: {
      handler: function (val) {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.getData()
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.pagination.currentPage = 1
        this.getData()
      },
      deep: true,
    },
  },
}
</script>

<style src="./Elements.scss" lang="scss" />
